import React from "react";

const ClicksIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.55554 9.19444V3.29167C5.55554 3.0154 5.66529 2.75045 5.86064 2.5551C6.05599 2.35975 6.32094 2.25 6.59721 2.25C6.87348 2.25 7.13843 2.35975 7.33378 2.5551C7.52913 2.75045 7.63888 3.0154 7.63888 3.29167V8.5M7.63888 8.15278V6.76389C7.63888 6.48762 7.74862 6.22267 7.94397 6.02732C8.13932 5.83197 8.40427 5.72222 8.68054 5.72222C8.95681 5.72222 9.22176 5.83197 9.41711 6.02732C9.61246 6.22267 9.72221 6.48762 9.72221 6.76389V8.5M9.72221 7.45833C9.72221 7.18207 9.83196 6.91711 10.0273 6.72176C10.2227 6.52641 10.4876 6.41667 10.7639 6.41667C11.0401 6.41667 11.3051 6.52641 11.5004 6.72176C11.6958 6.91711 11.8055 7.18207 11.8055 7.45833V8.5"
        stroke="#BF740A"
        strokeWidth="1.38889"
        strokeLinecap="round"
        strokeIinejoin="round"
      />
      <path
        d="M11.8055 8.15276C11.8055 7.8765 11.9153 7.61154 12.1106 7.41619C12.306 7.22084 12.5709 7.1111 12.8472 7.1111C13.1235 7.1111 13.3884 7.22084 13.5838 7.41619C13.7791 7.61154 13.8889 7.8765 13.8889 8.15276V11.2778C13.8889 12.3828 13.4499 13.4426 12.6685 14.224C11.8871 15.0054 10.8273 15.4444 9.7222 15.4444H8.33331H8.47776C7.78771 15.4445 7.10844 15.2733 6.50094 14.946C5.89344 14.6188 5.37673 14.1457 4.9972 13.5694L4.86109 13.3611C4.64442 13.0287 3.88378 11.7028 2.57915 9.38332C2.44613 9.14688 2.41059 8.86788 2.48011 8.60565C2.54962 8.34342 2.71869 8.11865 2.95137 7.97915C3.19931 7.83081 3.48964 7.76938 3.77641 7.8046C4.06319 7.83982 4.33003 7.96967 4.5347 8.1736L5.55554 9.19443M3.4722 2.24999L2.77776 1.55554M2.77776 5.02776H2.08331M9.7222 2.24999L10.4166 1.55554M10.4166 4.33332H11.1111"
        stroke="#BF740A"
        strokeWidth="1.38889"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ClicksIcon;
